import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { GlobalService } from './global.service';
import { catchError, map } from 'rxjs/operators';
export interface UploadResponse {
  ok: boolean;
  relativeUrl?: string;
  filename: string;
  mime?: string;
  size?: number;
  path?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  constructor(private http: HttpClient, public globalservice: GlobalService) { }

  ficha_cliente(idcliente: any): Observable<any> {

    const data = { idcliente };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'clientes/ficha';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  alta(nombre_asistente: any, chatgpt_asistente: any, token: any, vector: any): Observable<any> {
    const formData = new FormData();

    // Agregar otros datos al FormData
    /*formData.append('metatitle', otrosDatos.metatitle);
    formData.append('manufacturername', otrosDatos.manufacturername);
    formData.append('metadescription', otrosDatos.metadescription);*/

    // Agregar la imagen al FormData
    // formData.append('idcliente', datos.idcliente);
    formData.append('texto_cabecera', '¿Necesitas ayuda? ¡Conversemos!');
    formData.append('nombre_asistente', 'SonIA');
    formData.append('texto_presentacion', 'Adelante, pregúntame lo que quieras...');
    formData.append('nombre', nombre_asistente);
    formData.append('chatgpt_asistente', chatgpt_asistente);
    formData.append('token', token);
    //  formData.append('texto_presentacion', datos.texto_presentacion);
    formData.append('color1', '#000000');
    formData.append('color2', '#ffffff');
    //  formData.append('prom', datos.prom);
    formData.append('modelo', 'gpt-4o-mini');
    formData.append('temperatura', '1');
    formData.append('vector_id', vector);

    const url = this.globalservice.url_ws + 'clientes/alta';



    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  altausuarioasistente(idusuario: any, idcliente: any): Observable<any> {
    const formData = new FormData();


    formData.append('idusuario', idusuario);
    formData.append('idcliente', idcliente);


    const url = this.globalservice.url_ws + 'usuarios/altausuarioasistente';



    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  seleccionaasistente(idusuario: any, idcliente: any): Observable<any> {
    const formData = new FormData();


    formData.append('idusuario', idusuario);
    formData.append('idcliente', idcliente);


    const url = this.globalservice.url_ws + 'usuarios/seleccionaasistente';



    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  modifica(datos: any): Observable<any> {
    const formData = new FormData();

    // Agregar otros datos al FormData
    /*formData.append('metatitle', otrosDatos.metatitle);
    formData.append('manufacturername', otrosDatos.manufacturername);
    formData.append('metadescription', otrosDatos.metadescription);*/

    // Agregar la imagen al FormData
    formData.append('idcliente', datos.idcliente);
    formData.append('texto_cabecera', datos.texto_cabecera);
    formData.append('nombre_asistente', datos.nombre_asistente);
    formData.append('texto_presentacion', datos.texto_presentacion);
    formData.append('color1', datos.color1);
    formData.append('color2', datos.color2);
    formData.append('prom', datos.prom);
    formData.append('modelo', datos.modelo);
    formData.append('temperatura', datos.temperatura);
    formData.append('idinstruccion', datos.idinstruccion);
    formData.append('clientespotenciales', datos.clientespotenciales);
    formData.append('nombre_cp', datos.nombre_cp);
    formData.append('mail_cp', datos.mail_cp);
    formData.append('telefono_cp', datos.telefono_cp);
    console.log(datos);
    console.log('datos');
    const url = this.globalservice.url_ws + 'clientes/modificacion';



    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  modificaestilo(datos: any): Observable<any> {
    const formData = new FormData();

    // Agregar otros datos al FormData
    /*formData.append('metatitle', otrosDatos.metatitle);
    formData.append('manufacturername', otrosDatos.manufacturername);
    formData.append('metadescription', otrosDatos.metadescription);*/

    // Agregar la imagen al FormData
    formData.append('idcliente', datos.idcliente);
    formData.append('texto_cabecera', datos.texto_cabecera);
    formData.append('nombre_asistente', datos.nombre_asistente);
    formData.append('texto_presentacion', datos.texto_presentacion);
    formData.append('color1', datos.color1);
    formData.append('color2', datos.color2);
    formData.append('prom', datos.prom);
    formData.append('modelo', datos.modelo);
    formData.append('temperatura', datos.temperatura);
    formData.append('idinstruccion', datos.idinstruccion);
    formData.append('clientespotenciales', datos.clientespotenciales);
    formData.append('nombre_cp', datos.nombre_cp);
    formData.append('mail_cp', datos.mail_cp);
    formData.append('telefono_cp', datos.telefono_cp);
    console.log(datos);
    console.log('datos');
    const url = this.globalservice.url_ws + 'clientes/modificacionestilo';



    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  guardaimagen(imagen: File, datos: any): Observable<any> {

    const formData = new FormData();

    // Agregar otros datos al FormData
    /*formData.append('metatitle', otrosDatos.metatitle);
    formData.append('manufacturername', otrosDatos.manufacturername);
    formData.append('metadescription', otrosDatos.metadescription);*/

    // Agregar la imagen al FormData
    if (imagen) {
      formData.append('image', imagen, imagen.name);
      formData.append('idcliente', datos.idcliente);
    }

    const url = this.globalservice.url_ws + 'clientes/imagen';

    console.log(formData);

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }


  ficha_asistente(assistantId: any): Observable<any> {

    const data = { assistantId };
    console.log(data);
    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'chat/ficha';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }


  modifica_asistente(assistantId: any, texto: any, nombre: any, modelo: any, temperatura: any, chatgpt_apikey: any): Observable<any> {

    const data = { assistantId, texto, nombre, modelo, temperatura, chatgpt_apikey };
    console.log(data);
    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'chat/modifica';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  modifica_asistente_promt(assistantId: any, texto: any): Observable<any> {

    const data = { assistantId, texto };
    console.log(data);
    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'chat/modifica_promt';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  alta_asistente(texto: any): Observable<any> {

    const data = { texto };
    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'chat/alta';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  subirficheroxxx(assistantId: any, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file); // Añadir el archivo al FormData
    formData.append('assistantId', assistantId); // Añadir el ID del asistente al FormData
    console.log(formData);
    // URL del endpoint para la solicitud
    const url = this.globalservice.url_ws + 'chat/sube_fichero'; // Asegúrate de que esta URL es correcta para tu backend

    // Configurar las cabeceras para el envío de archivos (no es necesario establecer Content-Type, se manejará automáticamente)
    const headers = new HttpHeaders();

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData, { headers });
  }

  subirfichero(assistantId: string, file: File, instrucciones: string, vector_id: string): Observable<any> {
    console.log('Subiendo archivo:', file);
    console.log('ID del asistente:', assistantId);
    console.log('Instrucciones:', instrucciones);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('assistantId', assistantId);
    formData.append('instrucciones', instrucciones);
    formData.append('vector_id', vector_id);
    formData.append('chatgpt_apikey', this.globalservice.clientesesion.chatgpt_apikey);

    return this.http.post(`${this.globalservice.url_ws}chat/sube_fichero`, formData).pipe(
      map((response: any) => {
        console.log('Respuesta al subir el archivo:', response);
        if (response) {
          return response; // Respuesta válida
        } else {
          throw new Error('No se encontró el "id" en la respuesta.');
        }
      }),
      catchError((error) => {
        console.error('Error al subir el archivoz:', error);
        return throwError(error);
      })
    );
  }


  consultaficheroschatgpt(assistantId: string): Observable<any> {
    console.log('ID del asistente:', assistantId);
    const formData = new FormData();
    formData.append('assistantId', assistantId);

    return this.http.post(`${this.globalservice.url_ws}chat/consulta_ficheros`, formData).pipe(
      map((response: any) => {
        console.log('Respuesta consulta:', response);
        if (response) {
          return response; // Respuesta válida
        } else {
          throw new Error('No se encontró el "id" en la respuesta.');
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  eliminarfichero(fileId: any, assistantId: string, vectorid: any): Observable<any> {
    const formData = new FormData();
    formData.append('fileId', fileId);
    formData.append('assistantId', assistantId);
    formData.append('vectorid', vectorid);
    formData.append('chatgpt_apikey', this.globalservice.clientesesion.chatgpt_apikey);
    // formData.append('chatgpt_apikey', chatgpt_apikey);

    return this.http.post(`${this.globalservice.url_ws}chat/eliminar_fichero`, formData).pipe(
      map((response: any) => {
        console.log('Respuesta consulta:', response);
        if (response) {
          return response; // Respuesta válida
        } else {
          throw new Error('No se encontró el "id" en la respuesta.');
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  uploadFuente(file: File, idcliente: string, withCredentials = true): Observable<HttpEvent<UploadResponse>> {
    const form = new FormData();
    form.append('file', file);
    form.append('idcliente', idcliente);
    // HttpRequest te permite reportProgress + observe: 'events'
    const req = new HttpRequest<FormData>('POST',  'https://www.intelliassist.es/ws/documentos/upload.php', form);

    return this.http.request<UploadResponse>(req);
  
    /*return this.http.post<{ ok: boolean; relativeUrl?: string; filename: string }>(
      'https://www.intelliassist.es/ws/documentos/upload.php', // ajusta ruta real
      form,
      { reportProgress: true, observe: 'events' } // si quieres progreso
    );*/
  }

  altafuente(datos: any,file: File): Observable<any> {
    console.log('Datos de alta fuente:', datos);
    console.log('Archivo a subir:', file);
    if (!file) {
      console.error('No se ha proporcionado un archivo para subir.');
      return throwError('No se ha proporcionado un archivo para subir.');
    }
    console.log(datos);
    const formData = new FormData();
    formData.append('idcliente', datos.idcliente);
    formData.append('tipo', datos.tipo);
    formData.append('prom', datos.prom);
    formData.append('instrucciones', datos.instrucciones);
    formData.append('descripcion', datos.descripcion);
    formData.append('nbfichero', datos.nbfichero);
    formData.append('idfichero', datos.idfichero);
    formData.append('url', datos.url);
  formData.append('file', file );
    const url = this.globalservice.url_ws + 'fuentes/alta';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  modificafuente(datos: any): Observable<any> {
    console.log(datos);
    const formData = new FormData();
    formData.append('idfuente', datos.idfuente);
    formData.append('idcliente', datos.idcliente);
    formData.append('tipo', datos.tipo);
    formData.append('prom', datos.prom);
    formData.append('descripcion', datos.descripcion);
    formData.append('instrucciones', datos.instrucciones);
    formData.append('nbfichero', datos.nbfichero);
    formData.append('idfichero', datos.idfichero);
    formData.append('url', datos.url);

    const url = this.globalservice.url_ws + 'fuentes/modificacion';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  eliminarfuente(idfuente: any): Observable<any> {
    const formData = new FormData();
    formData.append('idfuente', idfuente);


    const url = this.globalservice.url_ws + 'fuentes/baja';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  consultaficheros(idcliente: any): Observable<any> {


    const data = { idcliente };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'fuentes/lista';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  consultaprom(idcliente: any): Observable<any> {


    const data = { idcliente };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'fuentes/devuelveprom';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }


  consultaasistentes(idusuario: any): Observable<any> {


    const data = { idusuario };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'usuarios/listaasistentes';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }


  crea_funcion_asistente(assistantId: any, nombreFuncion: any, descripcion: any, parametros: any): Observable<any> {

    //nombreFuncion ='mi primera funcion';
    //descripcion='esta es la descripcion';

    const data = { assistantId, nombreFuncion, descripcion, parametros };
    console.log(data);
    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'chat/creafuncion';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }


  cargamodulos(idasistente: any): Observable<any> {


    const data = { idasistente };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'modulos/lista';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  cargainstrucciones(): Observable<any> {


    const data = {};

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'instrucciones/lista';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }



  listaindicaciones(idcliente: any): Observable<any> {

    const data = { idcliente };

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'indicaciones/lista';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }


  listatiposvalor(): Observable<any> {

    const data = {};

    // URL del endpoint para la solicitud de login
    const url = this.globalservice.url_ws + 'indicaciones/listatiposvalores';

    // Configurar las cabeceras con el tipo de contenido JSON
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // Realizar la solicitud POST con datos JSON
    return this.http.post(url, data, { headers });
  }

  altaindicacion(datos: any): Observable<any> {
    console.log(datos);
    const formData = new FormData();
    formData.append('idcliente', this.globalservice.usuariosesion.idcliente);
    formData.append('idtipovalor', datos.idtipovalor);
    formData.append('descripcion', datos.descripcion);

    const url = this.globalservice.url_ws + 'indicaciones/alta';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  modificaindicacion(datos: any): Observable<any> {
    console.log(datos);
    const formData = new FormData();
    formData.append('id', datos.id);
    formData.append('idcliente', this.globalservice.usuariosesion.idcliente);
    formData.append('idtipovalor', datos.idtipovalor);
    formData.append('descripcion', datos.descripcion);

    const url = this.globalservice.url_ws + 'indicaciones/modifica';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }

  bajaindicacion(datos: any): Observable<any> {
    console.log(datos);
    const formData = new FormData();
    formData.append('id', datos.id);


    const url = this.globalservice.url_ws + 'indicaciones/baja';

    // Realizar la solicitud POST con FormData
    return this.http.post(url, formData);


  }


}
